import React from 'react';
import SeoMetadata from '../components/Seo/SeoMetadata';
import IntroPisoSpc from '../components/sections/Piso-Spc/IntroPisoSpc';
import TituloPisoSpc from '../components/sections/Piso-Spc/TituloPisoSpc';
import TituloRecubrimientoMuros from '../components/sections/RecubrimientosMuros/TituloRecubrimientoMuro';
import IntroMuros from '../components/sections/RecubrimientosMuros/IntroMuros'; 
import CatalogoMuros from '../components/sections/RecubrimientosMuros/CatalogoMuros';
import FormularioMuros from '../components/sections/RecubrimientosMuros/FormularioMuros';  
import Header from '../components/layouts/Header';
import Footer from '../components/layouts/Footer';

const RecubrimientosMuros = () => {
  return (
    <div>
      <SeoMetadata
        title="Recubrimientos para Muros | Decototal"
        description="Explora recubrimientos para muros, paneles decorativos y acabados para transformar tus espacios. Conoce el catálogo y cotiza con Decototal."
        keywords="recubrimientos para muros, paneles decorativos, revestimiento de paredes, acabados para muros"
        path="/recubrimientos-muros"
        image="/assets/img/recubrimientos-muros/recubrimientos-muros-intro.jpg"
      />
      <Header />
       {/* Sección introductoria del piso vinílico LVT */}
       <TituloRecubrimientoMuros />
       <CatalogoMuros /> 
       <IntroMuros />   
       <FormularioMuros/>  

      <Footer />
    </div>
  );
};

export default RecubrimientosMuros;